<template>
  <PropertyDetailsCard>
    <template #title>Description</template>
    <template #action>
      <PropertyDetailsCardEditButton v-if="hasInfo" @click="showModal" />
    </template>

    <PropertyDescriptionInfo v-if="hasInfo" :property="property" />
    <PropertyDetailsCardPlaceholder
      v-else
      title="You haven't added a description yet"
      subtitle="Use Tallo to help you generate a description that makes your rental standout"
      button-text="Add description"
      @button-clicked="showModal"
    />
    <PropertyDescriptionModal ref="descriptionModal" />
  </PropertyDetailsCard>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';

import { usePropertyStore } from '@tallo/investor/property';
import {
  PropertyDescriptionInfo,
  PropertyDetailsCard,
  PropertyDetailsCardEditButton,
  PropertyDetailsCardPlaceholder,
} from '@tallo/property';

import PropertyDescriptionModal from './property-description-modal.vue';

const descriptionModal = ref<InstanceType<typeof PropertyDescriptionModal>>();
const { property } = usePropertyStore();
const hasInfo = computed(() => Boolean(property?.description));

function showModal() {
  descriptionModal.value?.modalRef?.show();
}
</script>
